module.exports = __webpack_public_path__ + "media/unipod/pos_assembly_2-8cb118e2.jpg";